import { Modal } from "../ui/components";

export class ConfirmDeleteTabModal extends Modal {
    init() {
        super.init();
        this.bindEvents();
    }

    bindEvents() {
        this.cancelBtn?.on("click", () => {
            this.hide();
        });
    }

    show(tabName) {
        const tabNameEl = this.tabName?.el ? this.tabName.el() : this.tabName;
        if (tabNameEl) {
            tabNameEl.textContent = tabName || '';
        }
        super.show();
    }
}

